// component
import Iconify from "../../components/common/Iconify";
import dashboard from '../../images/dashboardIcon.svg'
import configurations from '../../images/configurationsIcon.svg'
import contents from '../../images/contentsIcon.svg'
import purchase from '../../images/purchaseIcon.svg'
import payout from '../../images/payoutsIcon.svg'
import players from '../../images/playesIcon.svg'
import potsIcon from '../../images/potsIcon.svg'
import leagues from '../../images/leaguesIcon.svg'
import user from '../../images/user.svg'
import child from '../../images/childIcon.svg'

import dashboard1 from '../../images/dashboardwhite.svg'
import configwhite from '../../images/configwhite.svg'
import childwhite from '../../images/childwhite.svg'
import leaguewhite from '../../images/leaguewhite.svg'

// import potwhite from '../../images/potswhite.svg'
import playerswhite from '../../images/playerswhite.svg'
import payoutwhite from '../../images/payoutwhite.svg'
import userwhite from '../../images/userswhite.svg'
import pots from '../../images/whitepot.svg'
// import hastag from'../../images/hastag.svg'

import hashtag from '../../images/hashtag.svg'
import hashtag1 from '../../images/hashtag1.svg'
import purchasewhite from '../../images/purchasewhite.svg'
import tokenTransfer from '../../images/token-transfer-dark.svg'
import tokenTransferLite from '../../images/token-transfer-light.svg'
import userLogsLight from '../../images/user-logs-dark.svg'
import userLogsDark from '../../images/user-logs-light.svg'
import serverDowntimeDark from '../../images/server-downtime-dark.svg'
import serverDowntimeLight from '../../images/server-downtime-light.svg'
import sheduleReportDark from '../../images/shedule-report-dark.svg'
import sheduleReportLight from '../../images/shedule-report-light.svg'
import InvoicesLight from '../../images/invoice_white.svg'
import InvoicesDark from '../../images/invoices_dark.svg'




// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} type='icon' width={22} height={22} />;
const getImage = (img) => <Iconify icon={img} type='image' width={22} height={22} />


const navConfig = [
  {
    title: "dashboard",
    path: "/dashboard",
    icon: getImage(dashboard),
    dark_icon: getImage(dashboard1),
     hasAccessMenu: "dashboard",
  },
  {
    title: "Seasons",
    path: "/seasons",
    // icon: getIcon("mdi:truck-fast-outline"),
    icon: getImage(leagues),
    dark_icon: getImage(leaguewhite),
    hasAccessMenu: "leagueseason",
  },
  {
    title: "Rounds",
    path: "/rounds",
    // icon: getIcon("mdi:office-building-outline"),
    icon: getImage(potsIcon),
    dark_icon: getImage(pots),
    hasAccessMenu: "pots"
  },
  {
    title: "Players",
    path: "/players",
    // icon: getIcon("mdi:map-marker-distance"),
    icon: getImage(players),
    dark_icon: getImage(playerswhite),
    hasAccessMenu: "players"
  },
  {
    title: "Users",
    path: "/users",
    // icon: getIcon("mdi:user-group"),
    icon: getImage(user),
    dark_icon: getImage(userwhite),
    hasAccessMenu: "user",
  },
  {
    title: "Payouts",
    path: "/payouts",
    // icon: getIcon("mdi:user-group"),
    icon: getImage(payout),
    dark_icon: getImage(payoutwhite),
    hasAccessMenu: "payout",
  },
  {
    title: "Purchases",
    path: "/purchases",
    // icon: getIcon("mdi:user-group"),
    icon: getImage(purchase),
    dark_icon: getImage(purchasewhite),
    hasAccessMenu: "paymentsreceipts"
  },
  {
    title: "Configurations",
    path: "/configurations",
    // icon: getIcon("mdi:chart-box-outline"),
    icon: getImage(configurations),
    dark_icon: getImage(configwhite),
    //hasAccessMenu:"potconfig" || "configuredleagues"  || "teams" || "leaguematchweek" ,
    hasAccessMenu: ["potconfig", "configuredleagues", "teams", "leaguematchweek", "game", "invoice", "advbanner", "tokentransferlimit", "primary_email"], 
    children: [
      {
        title: 'Round Parameters',
        path: '/configurations/roundparameters',
        icon: getImage(child),
        dark_icon: getImage(childwhite),
        hasAccessMenu: "potconfig" 
      },
      {
        title: 'Leagues',
        path: '/configurations/leagues',
        icon: getImage(child),
        dark_icon: getImage(childwhite),
        hasAccessMenu: "configuredleagues",
      },
      {
        title: 'Teams',
        path: '/configurations/teams',
        icon: getImage(child),
        dark_icon: getImage(childwhite),
        hasAccessMenu: "teams" 

      },
      {
        title: 'Match Weeks',
        path: '/configurations/matchweeks',
        icon: getImage(child),
        dark_icon: getImage(childwhite),
        hasAccessMenu: "leaguematchweek" 

      },
       {
        title: 'Sports & Leagues',
        path: '/configurations/sports&leagues',
        icon: getImage(child),
        dark_icon: getImage(childwhite),
        hasAccessMenu: "game" 

      },
        {
        title: 'Receipts & Invoices',
        path: '/configurations/receipts&invoices',
        icon: getImage(child),
        dark_icon: getImage(childwhite),
        hasAccessMenu: "invoice" 

      },
       {
        title: 'Token Transfer',
        path: '/configurations/tokentransfer',
        icon: getImage(child),
        dark_icon: getImage(childwhite),
        hasAccessMenu: "tokentransferlimit" 
       },
      {
        title: 'Adv Banners',
        path: '/configurations/advbanners',
        icon: getImage(child),
        dark_icon: getImage(childwhite),
        hasAccessMenu: "advbanner" 
      },
      {
        title: 'Email Configuration',
        path: '/configurations/emailConfiguration',
        icon: getImage(child),
        dark_icon: getImage(childwhite),
        hasAccessMenu: "primary_email" 
      }
    ],
  },
  {
    title: 'Customer Query',
    path: '/customer-query',
    icon: getImage(hashtag1),
    dark_icon: getImage(hashtag),
    hasAccess: true,
    hasAccessMenu: "tickets"
  },
  {
    title: 'Token Transfer',
    path: '/token-transfer',
    dark_icon: getImage(tokenTransferLite),
    icon: getImage(tokenTransfer),
    hasAccess: true,
    hasAccessMenu: "tokentransaction"
  },
    {
    title: 'User Logs',
    path: '/userlogs',
    dark_icon: getImage(userLogsDark),
    icon: getImage(userLogsLight),
    hasAccess: true,
    hasAccessMenu: "auditlog"
  },
  //   {
  //   title: 'Server Downtime Report',
  //   path: '/server-downtime-report',
  //   dark_icon: getImage(serverDowntimeLight),
  //   icon: getImage(serverDowntimeDark),
  //   hasAccess: true,
  //   hasAccessMenu: "serverreport"
  // },
  {
    title: 'Schedule Report',
    path: '/schedulereport',
    dark_icon: getImage(sheduleReportLight),
    icon: getImage(sheduleReportDark),
    hasAccess: true,
    hasAccessMenu: "schedulerreport"
  },
  {
    title: 'Invoices',
    path: '/invoices',
    dark_icon: getImage(InvoicesLight),
    icon: getImage(InvoicesDark),
    hasAccess: true,
    hasAccessMenu: "servicestatus"
  }
  // {
  //   title: "Contents",
  //   // path: "/contents",
  //   // icon: getIcon("material-symbols:chart-data-outline"),
  //   icon: getImage(contents),
  //   dark_icon:getImage(dashboard)

  // },
  // {
  //   title: 'login',
  //   path: '/login',
  //   icon: getIcon('eva:lock-fill'),
  // },
  // {
  //   title: 'register',
  //   path: '/register',
  //   icon: getIcon('eva:person-add-fill'),
  // },
  // {
  //   title: 'Not found',
  //   path: '/404',
  //   icon: getIcon('eva:alert-triangle-fill'),
  // },
];

export default navConfig;
